export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakaznikTitl';
export const NAME = 'ZakaznickyTitul';
